import { BRAND_LIST, CountryLanguageSwitcher, Languages } from 'typings'
import * as Typings from '../typings'

const SwedenLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'se',

  LONG_NAME: 'Sweden',
  SHORT_NAME: 'SE',

  DISPLAY_COUNTRY: 'Sweden',

  LANGUAGES: {
    EN: 'en', // The first language in this object is the default language for fallback redirect. For 26.10.0, make sure it's still EN
    SV: 'sv',
  },

  [BRAND_LIST.UQ]: {
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Sweden (English)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/se/en/',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/se/en/',
      CONTACT_US_URL: 'https://faq-se.uniqlo.com/',
      TERMS_OF_USE_URL:
        'https://faq-se.uniqlo.com/pkb_Home_UQ_SE?id=kA0Vh0000001MdM&l=en_US',
      PRIVACY_POLICY_URL:
        'https://faq-se.uniqlo.com/pkb_Home_UQ_SE?id=kA0Vh0000001MZZ&l=en_US',
    },
    [Languages.SV]: {
      LANGUAGE_CODE: 'sv',
      DISPLAY_NAME: 'Sweden (Svenska)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/se/sv/',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/se/sv/',
      CONTACT_US_URL: 'https://faq-se.uniqlo.com/pkb_Home_UQ_SE?l=sv',
      TERMS_OF_USE_URL:
        'https://faq-se.uniqlo.com/pkb_Home_UQ_SE?id=kA0Vh0000001MdM&l=sv',
      PRIVACY_POLICY_URL:
        'https://faq-se.uniqlo.com/pkb_Home_UQ_SE?id=kA0Vh0000001MZZ&l=sv',
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 62.0329767,
    INITIAL_LONGITUDE: 17.3787426,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Blekinge',
    '2': 'Dalarna',
    '3': 'Gävleborg',
    '4': 'Halland',
    '5': 'Jämtland',
    '6': 'Jönköping',
    '7': 'Kalmar',
    '8': 'Kronoberg',
    '9': 'Norrbotten',
    '10': 'Skåne',
    '11': 'Stockholm',
    '12': 'Södermanland',
    '13': 'Uppsala',
    '14': 'Värmland',
    '15': 'Västerbotten',
    '16': 'Västernorrland',
    '17': 'Västmanland',
    '18': 'Västra Götaland',
    '19': 'Örebro',
    '20': 'Östergötland',
  },

  MAP_URL: 'https://www.uniqlo.com/se/se/content/Stores_Landing_Page.html',

  POSTCODE_FORMAT: /^[0-9]{3} [0-9]{2}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default SwedenLocale
